import React from "react";
import connect from "Shared/connect";
import * as styles from "./base.scss";
import Icon from "Shared/Icon";
import SubCategory from "./../SubCategory";
import { pushState } from "Shared/history";
const SubCategories = (prop) => (React.createElement("div", { className: styles.container },
    React.createElement("a", { key: prop.mainCategory.url, className: styles.link, onClick: () => pushState(prop.mainCategory.url), tabIndex: prop.tabIndex },
        React.createElement("span", { className: styles.text },
            "Allt inom ",
            prop.mainCategory.displayName.toLowerCase()),
        React.createElement(Icon, { name: "arrow-right-new", className: styles.icon })),
    !!prop.mainCategory.children &&
        prop.mainCategory.children.map((x) => (React.createElement(SubCategory, { key: x.code, category: x, tabIndex: prop.tabIndex })))));
export default connect()(SubCategories);
